import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ModuleGuard } from '@/components/module-guard'

export const Route = createFileRoute('/hr/documents')({
  component: DocumentsLayout,
})

function DocumentsLayout() {
  return (
    <ModuleGuard moduleKey="hr">
      <Outlet />
    </ModuleGuard>
  )
}
